var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mx-auto",class:{
    'p-6 md:px-8 lg:py-8': !_vm.noSpacing,
    'max-w-8xl': !_vm.small,
    'max-w-5xl': _vm.small,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }